module.exports = __webpack_public_path__ + "static/media/outer-join-hero.3448b20f.svg";